import React, { useContext, useState } from "react";
import "./main.scss";
// import internet from "../../assets/icons/internet.png";
// import tv from "../../assets/icons/tv.png";
// import ip from "../../assets/icons/ip.png";
// import cam from "../../assets/icons/cam.png";
// import domPhone from "../../assets/icons/domPhone.png";
import HomePageContext from "../HomePageContext";
import HomeIcon from "@mui/icons-material/Home";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import ReceiptIcon from "@mui/icons-material/Receipt";
import NumbersIcon from "@mui/icons-material/Numbers";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Switch from "@mui/material/Switch";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DoorFrontIcon from "@mui/icons-material/DoorFront";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import HistoryIcon from "@mui/icons-material/History";

function MainInfo() {
  const {
    info,
    connInfo,
    intercomData,
    intercomLoading,
    openingDoor,
    openDoor,
    doorStatus,
    toast,
    setToast
  } = useContext(HomePageContext);
  let now = new Date();
  let my = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  const [checked, setChecked] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const token = localStorage.getItem("token") && localStorage.getItem("token");

  const [eventsModal, setEventsModal] = useState({
    open: false,
    domophone: null,
    day: new Date().toISOString().slice(0, 10),
    loading: false,
    events: []
  });

  const formatDay = (date = new Date()) => date.toISOString().slice(0, 10); // yyyy-mm-dd

  const openEvents = async (domophone, day = formatDay()) => {
    setEventsModal({
      open: true,
      domophone,
      day,
      loading: true,
      events: []
    });

    try {
      const body = new FormData();
      body.append("token", token);
      body.append("flatId", domophone.flatId);
      body.append("day", day);

      const res = await fetch("https://api.cyxym.net/app/v3?intercom.plog", {
        method: "POST",
        body
      });

      const json = await res.json();

      const payload = json?.response ?? json;
      const list = payload?.status ? payload.data || [] : [];

      setEventsModal(prev => ({
        ...prev,
        loading: false,
        events: list
      }));
    } catch (error) {
      console.error("Ошибка загрузки событий", error);
      setEventsModal(prev => ({
        ...prev,
        loading: false,
        events: []
      }));
      setToast({
        open: true,
        severity: "error",
        message: "Не удалось загрузить события"
      });
    }
  };

  const closeEvents = () => {
    setEventsModal({
      open: false,
      domophone: null,
      day: formatDay(),
      loading: false,
      events: []
    });
  };

  const changeEventsDay = day => {
    if (!eventsModal.domophone) return;
    openEvents(eventsModal.domophone, day);
  };

  const shiftDay = delta => {
    const d = new Date(eventsModal.day);
    d.setDate(d.getDate() + delta);
    changeEventsDay(formatDay(d));
  };

  // Человекочитаемое описание события (подставьте свои коды при необходимости)
  const eventLabel = event => {
    const map = {
      1: "Неотвеченный звонок",
      2: "Звонок в домофон",
      3: "Открывание ключом",
      4: "Открытие из приложения",
      5: "Открывание по лицу"
    };
    return map[String(event)] || `Событие ${event}`;
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleChange = e => {
    setChecked(e.target.checked);
  };

  const months = [
    "Января",
    "Февраля",
    "Марта",
    "Апреля",
    "Мая",
    "Июня",
    "Июля",
    "Августа",
    "Сентября",
    "Октября",
    "Ноября",
    "Декабря"
  ];

  const ont_states = {
    1: "Загиб волокна / Проблемы с волокном",
    2: "Обрыв волокна",
    3: "Потеря фреймов от ONU",
    8: "Порт административно погашен",
    13: "Нормальное отключение питания",
    "-1": "Не удалось получить состояние"
  };

  const getStatusClass = state => {
    if (state === "Услуга оказывается") {
      return "status_state_green";
    }

    if (state === "Услуга не оказывается (отсутствуют свободные средства)") {
      return "status_state_red";
    }

    return "status_state_else";
  };

  return (
    <div className="mainInfo">
      <span>Мои тарифы и услуги</span>
      <div className="mainContainer">
        <div className="top">
          <span className="connectedInfo">Информация:</span>
          <div className="infoCont">
            <div className="info card">
              <span className="name">{info?.fullname}</span>
              <div className="details">
                <span>
                  <ReceiptIcon /> Договор: {info?.contract}
                </span>
                <span>
                  <NumbersIcon /> Лицевой счет: {info?.id}
                </span>
                <span>
                  <HomeIcon /> Адрес: {info?.address}
                </span>

                <span>
                  <PhoneIphoneIcon /> Мобильный телефон: {"+" + info?.phone}
                </span>

                {info.last_pay !== null ? (
                  <span>
                    <CalendarMonthIcon /> Дата последнего платежа:{" "}
                    {info.last_pay}
                  </span>
                ) : null}
              </div>
            </div>
            {/* <div className="connectionInfo card">
              {connInfo.type === "eth" ? (
                <>
                  <div className="conn">
                    <span className="name">Тип подключения: </span>
                    <span>Ethernet</span>
                  </div>

                  <div className="connection">
                    <span>Статус коммутатора: </span>
                    <span>
                      {connInfo.switch_pinging ? "включен" : "выключен"}
                    </span>
                  </div>
                  <div className="connection">
                    <span>Статус порта: </span>
                    <span>
                      {connInfo.interface_admin_status === "active"
                        ? "включен"
                        : "выключен"}
                    </span>
                  </div>

                  <div className="connection">
                    <span>Время работы: </span>
                    <span>{connInfo.interface_uptime}</span>
                  </div>

                  <div className="connection">
                    <span>Входящий трафик: </span>
                    <span>{connInfo.interface_in_octets}</span>
                  </div>

                  <div className="connection">
                    <span>Исходящий трафик: </span>
                    <span>{connInfo.interface_out_octets}</span>
                  </div>
                </>
              ) : (
                <>
                  <div className="conn">
                    <span className="name">Тип подключения: </span>
                    <span>GPON</span>
                  </div>

                  <div className="connection">
                    <span>Статус устройства: </span>
                    <span>
                      {connInfo.ont_status === "online"
                        ? "включен"
                        : "выключен"}
                    </span>
                  </div>
                  <div className="connection">
                    <span>Время работы устройства: </span>
                    <span>{connInfo.uptime}</span>
                  </div>
                  <div className="connection">
                    <span>Последняя причина отключения устройства: </span>
                    <span>{ont_states[connInfo.ont_state]}</span>
                  </div>
                </>
              )}
            </div> */}
            <div className="payInfo card">
              <div className="tariff">
                <span>Тариф:</span>
                <span> {info.tariff}</span>
              </div>
              {info.price !== 0 ? (
                <span className="amount">Абонплата: {info.price} ₽</span>
              ) : null}
              <div className="payText">
                <div>
                  <span>Состояние:</span>
                  <span className={getStatusClass(info.state)}>
                    {" "}
                    {info.state}
                  </span>
                </div>
                {info.price !== 0 ? (
                  <div>
                    <span>Рекомендуемый платеж:</span>
                    <span className="rec_pay_col"> {info.rec_pay} ₽</span>
                  </div>
                ) : null}

                {info.tariff !== "Сотрудник" ? (
                  <>
                    <span>Списание</span>
                    <span>
                      1 {months[my.getMonth()]} {my.getFullYear()}
                    </span>
                  </>
                ) : null}
              </div>
            </div>

            {(intercomLoading || intercomData?.length > 0) && (
              <div className="domophoneInfo card">
                <div className="tariff">
                  <span>Домофония</span>
                </div>

                <div className="domophoneList">
                  {intercomLoading ? (
                    <div className="domophoneLoader">Загрузка домофонов...</div>
                  ) : (
                    intercomData.map(item => (
                      <div className="domophoneItem" key={item.domophoneId}>
                        <div className="domophoneAddress">
                          <HomeIcon />
                          <div>
                            <span>{item.address}</span>
                            <small>Подъезд: {item.entrance}</small>
                          </div>
                        </div>

                        <div className="domophoneActions">
                          <button
                            type="button"
                            className="eventsButton"
                            onClick={() => openEvents(item)}
                            title="События"
                          >
                            <HistoryIcon />
                          </button>

                          <button
                            className={`openDoorButton 
        ${openingDoor === item.domophoneId ? "opening" : ""}
        ${doorStatus[item.domophoneId] === "error" ? "error" : ""}
        ${doorStatus[item.domophoneId] === "success" ? "success" : ""}
      `}
                            onClick={() => openDoor(item)}
                          >
                            <DoorFrontIcon />
                          </button>
                        </div>
                      </div>

                      //                     <div className="domophoneItem" key={item.domophoneId}>
                      //                       <div className="domophoneAddress">
                      //                         <HomeIcon />
                      //                         <div>
                      //                           <span>{item.address}</span>
                      //                           <small>Подъезд: {item.entrance}</small>
                      //                         </div>
                      //                       </div>

                      //                       <button
                      //                         className={`openDoorButton
                      //   ${openingDoor === item.domophoneId ? "opening" : ""}
                      //   ${doorStatus[item.domophoneId] === "error" ? "error" : ""}
                      //   ${doorStatus[item.domophoneId] === "success" ? "success" : ""}
                      // `}
                      //                         onClick={() => openDoor(item)}
                      //                       >
                      //                         <DoorFrontIcon />
                      //                       </button>
                      //                     </div>
                    ))
                  )}
                </div>
              </div>
            )}

            {/* <div className="autoPay card">
              <div className="sett">
                <span>Настройки</span>
              </div>

              <div className="toggleText">
                <span>Автоплатежи</span>
                <Switch
                  checked={checked}
                  onChange={handleClickOpen}
                  size="small"
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Автоплатежи временно недоступны
        </DialogTitle>

        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Ок
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        onClose={() =>
          setToast(prev => ({
            ...prev,
            open: false
          }))
        }
      >
        <Alert
          severity={toast.severity}
          variant="filled"
          onClose={() =>
            setToast(prev => ({
              ...prev,
              open: false
            }))
          }
          sx={{ width: "100%" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>

      {eventsModal.open && (
        <div className="events-modal-overlay" onClick={closeEvents}>
          <div className="events-modal" onClick={e => e.stopPropagation()}>
            <div className="events-modal-header">
              <div>
                <div className="events-modal-title">
                  {eventsModal.domophone?.name ||
                    `Подъезд ${eventsModal.domophone?.entrance || ""}`}
                </div>
                <div className="events-modal-subtitle">
                  {[
                    eventsModal.domophone?.address,
                    eventsModal.domophone?.flat
                      ? `кв. ${eventsModal.domophone.flat}`
                      : null
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </div>
              </div>
              <button
                type="button"
                className="events-modal-close"
                onClick={closeEvents}
              >
                ×
              </button>
            </div>

            <div className="events-modal-day">
              <button type="button" onClick={() => shiftDay(-1)}>
                ‹
              </button>
              <input
                type="date"
                value={eventsModal.day}
                onChange={e => changeEventsDay(e.target.value)}
              />
              <button type="button" onClick={() => shiftDay(1)}>
                ›
              </button>
              <button
                type="button"
                onClick={() => changeEventsDay(formatDay())}
              >
                Сегодня
              </button>
            </div>

            <div className="events-modal-body">
              {eventsModal.loading && (
                <div className="events-modal-empty">Загрузка...</div>
              )}

              {!eventsModal.loading && eventsModal.events.length === 0 && (
                <div className="events-modal-empty">
                  Событий за этот день нет
                </div>
              )}

              {!eventsModal.loading &&
                eventsModal.events.map(item => (
                  <div key={item.uuid} className="events-item">
                    <div className="events-item-main">
                      <div className="events-item-time">{item.date}</div>
                      <div className="events-item-title">
                        {item.mechanizmaDescription || "Домофон"}
                      </div>
                      <div className="events-item-type">
                        {eventLabel(item.event)}
                      </div>
                    </div>

                    {item.preview && (
                      <a
                        href={item.preview}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="events-item-preview"
                      >
                        <img src={item.preview} alt="Превью" />
                      </a>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MainInfo;
